module.exports = __webpack_public_path__ + "static/media/icon_network_97.12f14838.png";